import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 * @class Contracts
 * @private
 */
export var Contracts = /*#__PURE__*/function () {
  function Contracts() {
    _classCallCheck(this, Contracts);
  }

  _createClass(Contracts, null, [{
    key: "throwIfNullOrUndefined",
    value: function throwIfNullOrUndefined(param, name) {
      if (param === undefined || param === null) {
        throw new Error("throwIfNullOrUndefined:" + name);
      }
    }
  }, {
    key: "throwIfNull",
    value: function throwIfNull(param, name) {
      if (param === null) {
        throw new Error("throwIfNull:" + name);
      }
    }
  }, {
    key: "throwIfNullOrWhitespace",
    value: function throwIfNullOrWhitespace(param, name) {
      Contracts.throwIfNullOrUndefined(param, name);

      if (("" + param).trim().length < 1) {
        throw new Error("throwIfNullOrWhitespace:" + name);
      }
    }
  }, {
    key: "throwIfDisposed",
    value: function throwIfDisposed(isDisposed) {
      if (isDisposed) {
        throw new Error("the object is already disposed");
      }
    }
  }, {
    key: "throwIfArrayEmptyOrWhitespace",
    value: function throwIfArrayEmptyOrWhitespace(array, name) {
      Contracts.throwIfNullOrUndefined(array, name);

      if (array.length === 0) {
        throw new Error("throwIfArrayEmptyOrWhitespace:" + name);
      }

      var _iterator = _createForOfIteratorHelper(array),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          Contracts.throwIfNullOrWhitespace(item, name);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "throwIfFileDoesNotExist",
    value: function throwIfFileDoesNotExist(param, name) {
      Contracts.throwIfNullOrWhitespace(param, name); // TODO check for file existence.
    }
  }, {
    key: "throwIfNotUndefined",
    value: function throwIfNotUndefined(param, name) {
      if (param !== undefined) {
        throw new Error("throwIfNotUndefined:" + name);
      }
    }
  }]);

  return Contracts;
}();